import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetProductionRecipeQueryVariables = Types.Exact<{
  productionRecipeId: Types.Scalars['String']['input'];
}>;


export type GetProductionRecipeQuery = { __typename?: 'Query', productionRecipe?: { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> } | null };

export type GetProductionRecipeChainQueryVariables = Types.Exact<{
  productionRecipeId: Types.Scalars['String']['input'];
  productionRecipeVariationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionRecipeChainQuery = { __typename?: 'Query', productionRecipeChain?: { __typename?: 'ProductionRecipeChain', recipe: { __typename?: 'ProductionRecipeChainNode', productionRecipeId: string, status: Types.ProductionRecipeStatus, isStartRecipe: boolean, isCombo: boolean, productionCatalogId: string, productionCategoryId: string, catalogGenus: string, catalogSeries: string, catalogColor: string, categoryCode: string, growWeeks?: number | null, plantsPerPot?: number | null, yield?: number | null }, variation: { __typename?: 'ProductionRecipeChainVariation', productionRecipeVariationId: string, growWeeks: number, plantsPerPot: number, yield: number }, upstream: Array<Array<{ __typename?: 'ProductionRecipeChainLink', parentProductionRecipeId?: string | null, productionCatalogId: string, productionCategoryId: string, catalogGenus: string, catalogSeries: string, catalogColor: string, categoryCode: string, componentsPerPot?: number | null, resolution: Types.ProductionRecipeChainLinkResolution, linkedRecipe?: { __typename?: 'ProductionRecipeChainNode', productionRecipeId: string, status: Types.ProductionRecipeStatus, isStartRecipe: boolean, isCombo: boolean, productionCatalogId: string, productionCategoryId: string, catalogGenus: string, catalogSeries: string, catalogColor: string, categoryCode: string, growWeeks?: number | null, plantsPerPot?: number | null, yield?: number | null } | null }>>, downstream: Array<Array<{ __typename?: 'ProductionRecipeChainNode', productionRecipeId: string, status: Types.ProductionRecipeStatus, isStartRecipe: boolean, isCombo: boolean, productionCatalogId: string, productionCategoryId: string, catalogGenus: string, catalogSeries: string, catalogColor: string, categoryCode: string, growWeeks?: number | null, plantsPerPot?: number | null, yield?: number | null }>> } | null };

export type GetProductionRecipeGroupsQueryVariables = Types.Exact<{
  groupBy: Types.ProductionRecipeGroupField;
  search?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionRecipeGroupsQuery = { __typename?: 'Query', productionRecipeGroups: Array<{ __typename?: 'ProductionRecipeGroupBucket', key: string, label: string, count: number }> };

export type GetProductionRecipesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionRecipeDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionRecipeDocumentSortInput> | Types.ProductionRecipeDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionRecipesQuery = { __typename?: 'Query', productionRecipes?: { __typename?: 'ProductionRecipesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionRecipeDocument', additionalCostEventIds: Array<string>, id: string, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, isStartRecipe: boolean, isCombo: boolean, laborSource: Types.RecipeLaborSource, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, numberOfVariations: number, catalogSeries: string, catalogGenus: string, catalogColor: string, categoryCode: string, taskEventIds: Array<string>, defaultVariation?: { __typename?: 'ProductionRecipeDefaultVariationSummary', growWeeks: number, plantsPerPot: number, yield: number } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetProductionRecipesLinkingPairQueryVariables = Types.Exact<{
  productionCatalogId: Types.Scalars['String']['input'];
  productionCategoryId: Types.Scalars['String']['input'];
}>;


export type GetProductionRecipesLinkingPairQuery = { __typename?: 'Query', productionRecipesLinkingPair: Array<{ __typename?: 'ProductionRecipeLinkingPair', productionRecipeId: string, catalogGenus: string, catalogSeries: string, catalogColor: string, categoryCode: string, status: Types.ProductionRecipeStatus, linkingVariationCount: number }> };

export type GetProductionRecipeVariationsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionRecipeVariationDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionRecipeVariationDocumentSortInput> | Types.ProductionRecipeVariationDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionRecipeVariationsQuery = { __typename?: 'Query', productionRecipeVariations?: { __typename?: 'ProductionRecipeVariationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionRecipeVariationDocument', id: string, tenantId: string, productionRecipeId: string, productionRecipeVariationId: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, parentCatalogGenus: string, parentCatalogSeries: string, parentCatalogColor: string, parentCategoryCode: string, parentIsCombo: boolean, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers: Array<{ __typename?: 'ProductionRecipeYieldTierDocument', thresholdQuantity: number, yield: number }>, links: Array<{ __typename?: 'ProductionRecipeLinkData', catalogGenus: string, catalogSeries: string, catalogColor: string, productionCatalogId: string, productionCatalogIdWithTenant: string, categoryCode: string, productionCategoryId: string, productionCategoryIdWithTenant: string, componentsPerPot?: number | null, linkedProductionRecipeId?: string | null, linkedRecipeStatus?: Types.ProductionRecipeStatus | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideDocument', defaultAssignedTo?: string | null, eventId: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRecipeVariationOptionsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionRecipeVariationDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetRecipeVariationOptionsQuery = { __typename?: 'Query', productionRecipeVariations?: { __typename?: 'ProductionRecipeVariationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionRecipeVariationDocument', customerName?: string | null, customerGroupName?: string | null, siteLocationName?: string | null, id: string, tenantId: string, productionRecipeId: string, productionRecipeVariationId: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, parentCatalogGenus: string, parentCatalogSeries: string, parentCatalogColor: string, parentCategoryCode: string, parentIsCombo: boolean, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers: Array<{ __typename?: 'ProductionRecipeYieldTierDocument', thresholdQuantity: number, yield: number }>, links: Array<{ __typename?: 'ProductionRecipeLinkData', catalogGenus: string, catalogSeries: string, catalogColor: string, productionCatalogId: string, productionCatalogIdWithTenant: string, categoryCode: string, productionCategoryId: string, productionCategoryIdWithTenant: string, componentsPerPot?: number | null, linkedProductionRecipeId?: string | null, linkedRecipeStatus?: Types.ProductionRecipeStatus | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideDocument', defaultAssignedTo?: string | null, eventId: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetRecipeVariationTagsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionRecipeVariationDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetRecipeVariationTagsQuery = { __typename?: 'Query', productionRecipeVariations?: { __typename?: 'ProductionRecipeVariationsConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionRecipeVariationDocument', id: string, customerName?: string | null, customerGroupName?: string | null, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, resolvedTag: { __typename?: 'ProduceTagResolutionResult', isResolved: boolean, matchedDimensions: Array<Types.ProduceTagDimension>, tagCode?: string | null, tagUpc?: string | null, tagSku?: string | null, materialItem?: { __typename?: 'MaterialItemDocument', tag?: { __typename?: 'MaterialItemTagData', source: Types.ProduceTagSource } | null } | null } }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ProductionRecipeDetailsFragment = { __typename?: 'ProductionRecipeStateData', additionalCostEventIds: Array<string>, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, genus?: string | null, series?: string | null, isStartRecipe: boolean, isCombo: boolean, version: number, laborSource: Types.RecipeLaborSource, taskEventIds: Array<string>, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideData', productionMaterialEventId: string, materialItemId: string, vendorId: string }>, variations: Array<{ __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> }> };

export type ProductionRecipeChainNodeFieldsFragment = { __typename?: 'ProductionRecipeChainNode', productionRecipeId: string, status: Types.ProductionRecipeStatus, isStartRecipe: boolean, isCombo: boolean, productionCatalogId: string, productionCategoryId: string, catalogGenus: string, catalogSeries: string, catalogColor: string, categoryCode: string, growWeeks?: number | null, plantsPerPot?: number | null, yield?: number | null };

export type ProductionRecipeLinkingPairFieldsFragment = { __typename?: 'ProductionRecipeLinkingPair', productionRecipeId: string, catalogGenus: string, catalogSeries: string, catalogColor: string, categoryCode: string, status: Types.ProductionRecipeStatus, linkingVariationCount: number };

export type ProductionRecipeSummaryFragment = { __typename?: 'ProductionRecipeDocument', additionalCostEventIds: Array<string>, id: string, tenantId: string, productionRecipeId: string, productionCategoryId: string, productionCatalogId: string, targetKind: Types.ProductionRecipeTargetKind, isStartRecipe: boolean, isCombo: boolean, laborSource: Types.RecipeLaborSource, flatRateCost?: number | null, status: Types.ProductionRecipeStatus, createdAt: Types.TDateISO, createdBy: string, updatedAt: Types.TDateISO, updatedBy: string, numberOfVariations: number, catalogSeries: string, catalogGenus: string, catalogColor: string, categoryCode: string, taskEventIds: Array<string>, defaultVariation?: { __typename?: 'ProductionRecipeDefaultVariationSummary', growWeeks: number, plantsPerPot: number, yield: number } | null };

export type EventAssignmentOverrideDataFieldsFragment = { __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string };

export type EventAssignmentOverrideDocumentFieldsFragment = { __typename?: 'EventAssignmentOverrideDocument', defaultAssignedTo?: string | null, eventId: string };

export type ProductionRecipeVariationDetailsFragment = { __typename?: 'ProductionRecipeVariationData', id: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers?: Array<{ __typename?: 'ProductionRecipeYieldTier', thresholdQuantity: number, yield: number }> | null, links: Array<{ __typename?: 'ProductionRecipeLink', productionCatalogId: string, productionCategoryId: string, componentsPerPot?: number | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideData', defaultAssignedTo?: string | null, eventId: string }> };

export type ProductionRecipeVariationSummaryFragment = { __typename?: 'ProductionRecipeVariationDocument', id: string, tenantId: string, productionRecipeId: string, productionRecipeVariationId: string, customerId?: string | null, customerGroupId?: string | null, siteLocationId?: string | null, growWeeks: number, plantsPerPot: number, yield: number, parentCatalogGenus: string, parentCatalogSeries: string, parentCatalogColor: string, parentCategoryCode: string, parentIsCombo: boolean, materialEventIds: Array<string>, spaceEventIds: Array<string>, taskEventIds: Array<string>, excludedMaterialEventIds: Array<string>, excludedSpaceEventIds: Array<string>, excludedTaskEventIds: Array<string>, weekRange?: { __typename?: 'ProductionRecipeWeekRange', startWeek: number, endWeek: number } | null, yieldTiers: Array<{ __typename?: 'ProductionRecipeYieldTierDocument', thresholdQuantity: number, yield: number }>, links: Array<{ __typename?: 'ProductionRecipeLinkData', catalogGenus: string, catalogSeries: string, catalogColor: string, productionCatalogId: string, productionCatalogIdWithTenant: string, categoryCode: string, productionCategoryId: string, productionCategoryIdWithTenant: string, componentsPerPot?: number | null, linkedProductionRecipeId?: string | null, linkedRecipeStatus?: Types.ProductionRecipeStatus | null }>, taskEventAssignmentOverrides: Array<{ __typename?: 'EventAssignmentOverrideDocument', defaultAssignedTo?: string | null, eventId: string }> };

export type CalculateRecipeCostQueryVariables = Types.Exact<{
  productionRecipeId: Types.Scalars['String']['input'];
  productionRecipeVariationId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  siteLocationId: Types.Scalars['String']['input'];
}>;


export type CalculateRecipeCostQuery = { __typename?: 'Query', calculateRecipeCost?: { __typename?: 'RecipeCostSummaryResult', additionalCost: number, computedTotalCost: number, costSource: Types.RecipeCostSource, directCost: number, incompleteCostReasons: Array<string>, isComplete: boolean, laborCost: number, laborCostSource: Types.RecipeLaborSource, materialsCost: number, overallStatus: Types.CostCalcStepSeverity, overheadCost: number, plugCost: number, supplierRoyaltyCost: number, supplierRoyaltyCoverage: Types.SupplierRoyaltyCoverage, totalCost: number, calcSteps: Array<{ __typename?: 'CostCalcStep', code: string, message: string, severity: Types.CostCalcStepSeverity, context: Array<{ __typename?: 'CostCalcStepContextEntry', entityId?: string | null, entityType?: string | null, key: string, value: string }> }> } | null };

export type GetProductionRecipeBomQueryVariables = Types.Exact<{
  productionRecipeVariationId: Types.Scalars['String']['input'];
}>;


export type GetProductionRecipeBomQuery = { __typename?: 'Query', productionRecipeBom?: { __typename?: 'ProductionRecipeBom', productionRecipeId: string, productionRecipeVariationId: string, distinctMaterialCount: number, entries: Array<{ __typename?: 'ProductionRecipeBomEntry', materialItemId: string, materialItemName: string, materialItemCategory: string, materialEventId: string, materialEventName: string, materialEventDetailId: string, description: string, quantity: number }> } | null };

export type ProductionRecipeBomFragment = { __typename?: 'ProductionRecipeBom', productionRecipeId: string, productionRecipeVariationId: string, distinctMaterialCount: number, entries: Array<{ __typename?: 'ProductionRecipeBomEntry', materialItemId: string, materialItemName: string, materialItemCategory: string, materialEventId: string, materialEventName: string, materialEventDetailId: string, description: string, quantity: number }> };

export type ProductionRecipeBomEntryFragment = { __typename?: 'ProductionRecipeBomEntry', materialItemId: string, materialItemName: string, materialItemCategory: string, materialEventId: string, materialEventName: string, materialEventDetailId: string, description: string, quantity: number };

export type GetProductionRecipeHistoryQueryVariables = Types.Exact<{
  productionRecipeId: Types.Scalars['String']['input'];
}>;


export type GetProductionRecipeHistoryQuery = { __typename?: 'Query', productionRecipeHistory: Array<{ __typename?: 'ProductionRecipeHistoryRecord', id: string, summary: string, occurredAt: Types.TDateISO, occurredBy: string, productionRecipeVariationId?: string | null, changes: Array<{ __typename?: 'ProductionRecipeHistoryChange', fieldName: string, summary: string }> }> };

export type GetProductionRecipeMaterialVendorOverridesQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionRecipeDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.ProductionRecipeDocumentSortInput> | Types.ProductionRecipeDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetProductionRecipeMaterialVendorOverridesQuery = { __typename?: 'Query', productionRecipes?: { __typename?: 'ProductionRecipesConnection', totalCount: number, nodes?: Array<{ __typename?: 'ProductionRecipeDocument', productionRecipeId: string, materialEventVendorOverrides: Array<{ __typename?: 'MaterialEventVendorOverrideDocument', productionMaterialEventId: string, materialItemId: string, vendorId: string }> }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type MaterialEventVendorOverrideFragment = { __typename?: 'MaterialEventVendorOverrideDocument', productionMaterialEventId: string, materialItemId: string, vendorId: string };

export type GetProductionRecipeVariationEffectiveYieldQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.ProductionRecipeVariationDocumentFilterInput>;
  plannedQuantity: Types.Scalars['Int']['input'];
  first: Types.Scalars['Int']['input'];
}>;


export type GetProductionRecipeVariationEffectiveYieldQuery = { __typename?: 'Query', productionRecipeVariations?: { __typename?: 'ProductionRecipeVariationsConnection', nodes?: Array<{ __typename?: 'ProductionRecipeVariationDocument', productionRecipeVariationId: string, effectiveYield: { __typename?: 'ProductionRecipeEffectiveYield', baseYield: number, tierThresholdQuantity?: number | null, yield: number } }> | null } | null };

export const EventAssignmentOverrideDataFieldsFragmentDoc = new TypedDocumentString(`
    fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}
    `, {"fragmentName":"EventAssignmentOverrideDataFields"});
export const ProductionRecipeVariationDetailsFragmentDoc = new TypedDocumentString(`
    fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}
    fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}`, {"fragmentName":"ProductionRecipeVariationDetails"});
export const ProductionRecipeDetailsFragmentDoc = new TypedDocumentString(`
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
    fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}`, {"fragmentName":"ProductionRecipeDetails"});
export const ProductionRecipeChainNodeFieldsFragmentDoc = new TypedDocumentString(`
    fragment ProductionRecipeChainNodeFields on ProductionRecipeChainNode {
  productionRecipeId
  status
  isStartRecipe
  isCombo
  productionCatalogId
  productionCategoryId
  catalogGenus
  catalogSeries
  catalogColor
  categoryCode
  growWeeks
  plantsPerPot
  yield
}
    `, {"fragmentName":"ProductionRecipeChainNodeFields"});
export const ProductionRecipeLinkingPairFieldsFragmentDoc = new TypedDocumentString(`
    fragment ProductionRecipeLinkingPairFields on ProductionRecipeLinkingPair {
  productionRecipeId
  catalogGenus
  catalogSeries
  catalogColor
  categoryCode
  status
  linkingVariationCount
}
    `, {"fragmentName":"ProductionRecipeLinkingPairFields"});
export const ProductionRecipeSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionRecipeSummary on ProductionRecipeDocument {
  additionalCostEventIds
  id
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  isStartRecipe
  isCombo
  laborSource
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
  numberOfVariations
  catalogSeries
  catalogGenus
  catalogColor
  categoryCode
  taskEventIds
  defaultVariation {
    growWeeks
    plantsPerPot
    yield
  }
}
    `, {"fragmentName":"ProductionRecipeSummary"});
export const EventAssignmentOverrideDocumentFieldsFragmentDoc = new TypedDocumentString(`
    fragment EventAssignmentOverrideDocumentFields on EventAssignmentOverrideDocument {
  defaultAssignedTo
  eventId
}
    `, {"fragmentName":"EventAssignmentOverrideDocumentFields"});
export const ProductionRecipeVariationSummaryFragmentDoc = new TypedDocumentString(`
    fragment ProductionRecipeVariationSummary on ProductionRecipeVariationDocument {
  id
  tenantId
  productionRecipeId
  productionRecipeVariationId
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  parentCatalogGenus
  parentCatalogSeries
  parentCatalogColor
  parentCategoryCode
  parentIsCombo
  links {
    catalogGenus
    catalogSeries
    catalogColor
    productionCatalogId
    productionCatalogIdWithTenant
    categoryCode
    productionCategoryId
    productionCategoryIdWithTenant
    componentsPerPot
    linkedProductionRecipeId
    linkedRecipeStatus
  }
  materialEventIds
  spaceEventIds
  taskEventIds
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDocumentFields
  }
}
    fragment EventAssignmentOverrideDocumentFields on EventAssignmentOverrideDocument {
  defaultAssignedTo
  eventId
}`, {"fragmentName":"ProductionRecipeVariationSummary"});
export const ProductionRecipeBomEntryFragmentDoc = new TypedDocumentString(`
    fragment ProductionRecipeBomEntry on ProductionRecipeBomEntry {
  materialItemId
  materialItemName
  materialItemCategory
  materialEventId
  materialEventName
  materialEventDetailId
  description
  quantity
}
    `, {"fragmentName":"ProductionRecipeBomEntry"});
export const ProductionRecipeBomFragmentDoc = new TypedDocumentString(`
    fragment ProductionRecipeBom on ProductionRecipeBom {
  productionRecipeId
  productionRecipeVariationId
  distinctMaterialCount
  entries {
    ...ProductionRecipeBomEntry
  }
}
    fragment ProductionRecipeBomEntry on ProductionRecipeBomEntry {
  materialItemId
  materialItemName
  materialItemCategory
  materialEventId
  materialEventName
  materialEventDetailId
  description
  quantity
}`, {"fragmentName":"ProductionRecipeBom"});
export const MaterialEventVendorOverrideFragmentDoc = new TypedDocumentString(`
    fragment MaterialEventVendorOverride on MaterialEventVendorOverrideDocument {
  productionMaterialEventId
  materialItemId
  vendorId
}
    `, {"fragmentName":"MaterialEventVendorOverride"});
export const GetProductionRecipeDocument = new TypedDocumentString(`
    query GetProductionRecipe($productionRecipeId: String!) {
  productionRecipe(productionRecipeId: $productionRecipeId) {
    ...ProductionRecipeDetails
  }
}
    fragment ProductionRecipeDetails on ProductionRecipeStateData {
  additionalCostEventIds
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  genus
  series
  isStartRecipe
  isCombo
  version
  laborSource
  taskEventIds
  materialEventVendorOverrides {
    productionMaterialEventId
    materialItemId
    vendorId
  }
  variations {
    ...ProductionRecipeVariationDetails
  }
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
}
fragment EventAssignmentOverrideDataFields on EventAssignmentOverrideData {
  defaultAssignedTo
  eventId
}
fragment ProductionRecipeVariationDetails on ProductionRecipeVariationData {
  id
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  links {
    productionCatalogId
    productionCategoryId
    componentsPerPot
  }
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  materialEventIds
  spaceEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDataFields
  }
  taskEventIds
}`);
export const GetProductionRecipeChainDocument = new TypedDocumentString(`
    query GetProductionRecipeChain($productionRecipeId: String!, $productionRecipeVariationId: String) {
  productionRecipeChain(
    productionRecipeId: $productionRecipeId
    productionRecipeVariationId: $productionRecipeVariationId
  ) {
    recipe {
      ...ProductionRecipeChainNodeFields
    }
    variation {
      productionRecipeVariationId
      growWeeks
      plantsPerPot
      yield
    }
    upstream {
      parentProductionRecipeId
      productionCatalogId
      productionCategoryId
      catalogGenus
      catalogSeries
      catalogColor
      categoryCode
      componentsPerPot
      resolution
      linkedRecipe {
        ...ProductionRecipeChainNodeFields
      }
    }
    downstream {
      ...ProductionRecipeChainNodeFields
    }
  }
}
    fragment ProductionRecipeChainNodeFields on ProductionRecipeChainNode {
  productionRecipeId
  status
  isStartRecipe
  isCombo
  productionCatalogId
  productionCategoryId
  catalogGenus
  catalogSeries
  catalogColor
  categoryCode
  growWeeks
  plantsPerPot
  yield
}`);
export const GetProductionRecipeGroupsDocument = new TypedDocumentString(`
    query GetProductionRecipeGroups($groupBy: ProductionRecipeGroupField!, $search: String) {
  productionRecipeGroups(groupBy: $groupBy, search: $search) {
    key
    label
    count
  }
}
    `);
export const GetProductionRecipesDocument = new TypedDocumentString(`
    query GetProductionRecipes($where: ProductionRecipeDocumentFilterInput, $order: [ProductionRecipeDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionRecipes(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...ProductionRecipeSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment ProductionRecipeSummary on ProductionRecipeDocument {
  additionalCostEventIds
  id
  tenantId
  productionRecipeId
  productionCategoryId
  productionCatalogId
  targetKind
  isStartRecipe
  isCombo
  laborSource
  flatRateCost
  status
  createdAt
  createdBy
  updatedAt
  updatedBy
  numberOfVariations
  catalogSeries
  catalogGenus
  catalogColor
  categoryCode
  taskEventIds
  defaultVariation {
    growWeeks
    plantsPerPot
    yield
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionRecipesLinkingPairDocument = new TypedDocumentString(`
    query GetProductionRecipesLinkingPair($productionCatalogId: String!, $productionCategoryId: String!) {
  productionRecipesLinkingPair(
    productionCatalogId: $productionCatalogId
    productionCategoryId: $productionCategoryId
  ) {
    ...ProductionRecipeLinkingPairFields
  }
}
    fragment ProductionRecipeLinkingPairFields on ProductionRecipeLinkingPair {
  productionRecipeId
  catalogGenus
  catalogSeries
  catalogColor
  categoryCode
  status
  linkingVariationCount
}`);
export const GetProductionRecipeVariationsDocument = new TypedDocumentString(`
    query GetProductionRecipeVariations($where: ProductionRecipeVariationDocumentFilterInput, $order: [ProductionRecipeVariationDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionRecipeVariations(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...ProductionRecipeVariationSummary
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment EventAssignmentOverrideDocumentFields on EventAssignmentOverrideDocument {
  defaultAssignedTo
  eventId
}
fragment ProductionRecipeVariationSummary on ProductionRecipeVariationDocument {
  id
  tenantId
  productionRecipeId
  productionRecipeVariationId
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  parentCatalogGenus
  parentCatalogSeries
  parentCatalogColor
  parentCategoryCode
  parentIsCombo
  links {
    catalogGenus
    catalogSeries
    catalogColor
    productionCatalogId
    productionCatalogIdWithTenant
    categoryCode
    productionCategoryId
    productionCategoryIdWithTenant
    componentsPerPot
    linkedProductionRecipeId
    linkedRecipeStatus
  }
  materialEventIds
  spaceEventIds
  taskEventIds
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDocumentFields
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetRecipeVariationOptionsDocument = new TypedDocumentString(`
    query GetRecipeVariationOptions($where: ProductionRecipeVariationDocumentFilterInput, $first: Int, $after: String) {
  productionRecipeVariations(where: $where, first: $first, after: $after) {
    nodes {
      ...ProductionRecipeVariationSummary
      customerName
      customerGroupName
      siteLocationName
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment EventAssignmentOverrideDocumentFields on EventAssignmentOverrideDocument {
  defaultAssignedTo
  eventId
}
fragment ProductionRecipeVariationSummary on ProductionRecipeVariationDocument {
  id
  tenantId
  productionRecipeId
  productionRecipeVariationId
  customerId
  customerGroupId
  siteLocationId
  weekRange {
    startWeek
    endWeek
  }
  growWeeks
  plantsPerPot
  yield
  yieldTiers {
    thresholdQuantity
    yield
  }
  parentCatalogGenus
  parentCatalogSeries
  parentCatalogColor
  parentCategoryCode
  parentIsCombo
  links {
    catalogGenus
    catalogSeries
    catalogColor
    productionCatalogId
    productionCatalogIdWithTenant
    categoryCode
    productionCategoryId
    productionCategoryIdWithTenant
    componentsPerPot
    linkedProductionRecipeId
    linkedRecipeStatus
  }
  materialEventIds
  spaceEventIds
  taskEventIds
  excludedMaterialEventIds
  excludedSpaceEventIds
  excludedTaskEventIds
  taskEventAssignmentOverrides {
    ...EventAssignmentOverrideDocumentFields
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetRecipeVariationTagsDocument = new TypedDocumentString(`
    query GetRecipeVariationTags($where: ProductionRecipeVariationDocumentFilterInput, $first: Int) {
  productionRecipeVariations(where: $where, first: $first) {
    nodes {
      id
      customerName
      customerGroupName
      weekRange {
        startWeek
        endWeek
      }
      resolvedTag {
        ...ProduceTagResolution
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment ProduceTagResolution on ProduceTagResolutionResult {
  isResolved
  matchedDimensions
  tagCode
  tagUpc
  tagSku
  materialItem {
    tag {
      source
    }
  }
}`);
export const CalculateRecipeCostDocument = new TypedDocumentString(`
    query CalculateRecipeCost($productionRecipeId: String!, $productionRecipeVariationId: String, $siteLocationId: String!) {
  calculateRecipeCost(
    productionRecipeId: $productionRecipeId
    productionRecipeVariationId: $productionRecipeVariationId
    siteLocationId: $siteLocationId
  ) {
    additionalCost
    calcSteps {
      code
      context {
        entityId
        entityType
        key
        value
      }
      message
      severity
    }
    computedTotalCost
    costSource
    directCost
    incompleteCostReasons
    isComplete
    laborCost
    laborCostSource
    materialsCost
    overallStatus
    overheadCost
    plugCost
    supplierRoyaltyCost
    supplierRoyaltyCoverage
    totalCost
  }
}
    `);
export const GetProductionRecipeBomDocument = new TypedDocumentString(`
    query GetProductionRecipeBom($productionRecipeVariationId: String!) {
  productionRecipeBom(productionRecipeVariationId: $productionRecipeVariationId) {
    ...ProductionRecipeBom
  }
}
    fragment ProductionRecipeBom on ProductionRecipeBom {
  productionRecipeId
  productionRecipeVariationId
  distinctMaterialCount
  entries {
    ...ProductionRecipeBomEntry
  }
}
fragment ProductionRecipeBomEntry on ProductionRecipeBomEntry {
  materialItemId
  materialItemName
  materialItemCategory
  materialEventId
  materialEventName
  materialEventDetailId
  description
  quantity
}`);
export const GetProductionRecipeHistoryDocument = new TypedDocumentString(`
    query GetProductionRecipeHistory($productionRecipeId: String!) {
  productionRecipeHistory(productionRecipeId: $productionRecipeId) {
    id
    summary
    occurredAt
    occurredBy
    productionRecipeVariationId
    changes {
      fieldName
      summary
    }
  }
}
    `);
export const GetProductionRecipeMaterialVendorOverridesDocument = new TypedDocumentString(`
    query GetProductionRecipeMaterialVendorOverrides($where: ProductionRecipeDocumentFilterInput, $order: [ProductionRecipeDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  productionRecipes(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      productionRecipeId
      materialEventVendorOverrides {
        ...MaterialEventVendorOverride
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment MaterialEventVendorOverride on MaterialEventVendorOverrideDocument {
  productionMaterialEventId
  materialItemId
  vendorId
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetProductionRecipeVariationEffectiveYieldDocument = new TypedDocumentString(`
    query GetProductionRecipeVariationEffectiveYield($where: ProductionRecipeVariationDocumentFilterInput, $plannedQuantity: Int!, $first: Int!) {
  productionRecipeVariations(where: $where, first: $first) {
    nodes {
      productionRecipeVariationId
      effectiveYield(plannedQuantity: $plannedQuantity) {
        baseYield
        tierThresholdQuantity
        yield
      }
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetProductionRecipe: build.query<GetProductionRecipeQuery, GetProductionRecipeQueryVariables>({
      query: (variables) => ({ document: GetProductionRecipeDocument, variables })
    }),
    GetProductionRecipeChain: build.query<GetProductionRecipeChainQuery, GetProductionRecipeChainQueryVariables>({
      query: (variables) => ({ document: GetProductionRecipeChainDocument, variables })
    }),
    GetProductionRecipeGroups: build.query<GetProductionRecipeGroupsQuery, GetProductionRecipeGroupsQueryVariables>({
      query: (variables) => ({ document: GetProductionRecipeGroupsDocument, variables })
    }),
    GetProductionRecipes: build.query<GetProductionRecipesQuery, GetProductionRecipesQueryVariables | void>({
      query: (variables) => ({ document: GetProductionRecipesDocument, variables })
    }),
    GetProductionRecipesLinkingPair: build.query<GetProductionRecipesLinkingPairQuery, GetProductionRecipesLinkingPairQueryVariables>({
      query: (variables) => ({ document: GetProductionRecipesLinkingPairDocument, variables })
    }),
    GetProductionRecipeVariations: build.query<GetProductionRecipeVariationsQuery, GetProductionRecipeVariationsQueryVariables | void>({
      query: (variables) => ({ document: GetProductionRecipeVariationsDocument, variables })
    }),
    GetRecipeVariationOptions: build.query<GetRecipeVariationOptionsQuery, GetRecipeVariationOptionsQueryVariables | void>({
      query: (variables) => ({ document: GetRecipeVariationOptionsDocument, variables })
    }),
    GetRecipeVariationTags: build.query<GetRecipeVariationTagsQuery, GetRecipeVariationTagsQueryVariables | void>({
      query: (variables) => ({ document: GetRecipeVariationTagsDocument, variables })
    }),
    CalculateRecipeCost: build.query<CalculateRecipeCostQuery, CalculateRecipeCostQueryVariables>({
      query: (variables) => ({ document: CalculateRecipeCostDocument, variables })
    }),
    GetProductionRecipeBom: build.query<GetProductionRecipeBomQuery, GetProductionRecipeBomQueryVariables>({
      query: (variables) => ({ document: GetProductionRecipeBomDocument, variables })
    }),
    GetProductionRecipeHistory: build.query<GetProductionRecipeHistoryQuery, GetProductionRecipeHistoryQueryVariables>({
      query: (variables) => ({ document: GetProductionRecipeHistoryDocument, variables })
    }),
    GetProductionRecipeMaterialVendorOverrides: build.query<GetProductionRecipeMaterialVendorOverridesQuery, GetProductionRecipeMaterialVendorOverridesQueryVariables | void>({
      query: (variables) => ({ document: GetProductionRecipeMaterialVendorOverridesDocument, variables })
    }),
    GetProductionRecipeVariationEffectiveYield: build.query<GetProductionRecipeVariationEffectiveYieldQuery, GetProductionRecipeVariationEffectiveYieldQueryVariables>({
      query: (variables) => ({ document: GetProductionRecipeVariationEffectiveYieldDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetProductionRecipeQuery, useLazyGetProductionRecipeQuery, useGetProductionRecipeChainQuery, useLazyGetProductionRecipeChainQuery, useGetProductionRecipeGroupsQuery, useLazyGetProductionRecipeGroupsQuery, useGetProductionRecipesQuery, useLazyGetProductionRecipesQuery, useGetProductionRecipesLinkingPairQuery, useLazyGetProductionRecipesLinkingPairQuery, useGetProductionRecipeVariationsQuery, useLazyGetProductionRecipeVariationsQuery, useGetRecipeVariationOptionsQuery, useLazyGetRecipeVariationOptionsQuery, useGetRecipeVariationTagsQuery, useLazyGetRecipeVariationTagsQuery, useCalculateRecipeCostQuery, useLazyCalculateRecipeCostQuery, useGetProductionRecipeBomQuery, useLazyGetProductionRecipeBomQuery, useGetProductionRecipeHistoryQuery, useLazyGetProductionRecipeHistoryQuery, useGetProductionRecipeMaterialVendorOverridesQuery, useLazyGetProductionRecipeMaterialVendorOverridesQuery, useGetProductionRecipeVariationEffectiveYieldQuery, useLazyGetProductionRecipeVariationEffectiveYieldQuery } = injectedRtkApi;
